import { createContext, useContext, useState, useEffect } from 'react';
import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

const SiteSettingsContext = createContext(null);

export const useSiteSettings = () => {
  const context = useContext(SiteSettingsContext);
  if (!context) {
    throw new Error('useSiteSettings must be used within a SiteSettingsProvider');
  }
  return context;
};

export const SiteSettingsProvider = ({ children }) => {
  const [settings, setSettings] = useState(null);
  const [loading, setLoading] = useState(true);

  const fetchSettings = async () => {
    try {
      const response = await axios.get(`${API}/settings/public`);
      setSettings(response.data);
    } catch (error) {
      console.error('Error fetching settings:', error);
      // Use default values if API fails
      setSettings({});
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchSettings();
  }, []);

  const refreshSettings = () => {
    fetchSettings();
  };

  // Helper function to get a setting with fallback
  const getSetting = (key, fallback = '') => {
    return settings?.[key] || fallback;
  };

  return (
    <SiteSettingsContext.Provider value={{ settings, loading, getSetting, refreshSettings }}>
      {children}
    </SiteSettingsContext.Provider>
  );
};

export default SiteSettingsContext;
